import Container from './Container';
import Heading from './Heading';

export { Container, Heading };
